import './styles/index.css';
import './styles/new_style.css';
import './styles/responsive.css';
import './styles/login.css';
import './styles/booking.css'

import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';

import App from './App';
import { AuthenticationProvider } from './context/AuthenticationContext';
import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';

const queryClient = new QueryClient();

ReactDOM.render(
<React.StrictMode>
  <AuthenticationProvider>
    <QueryClientProvider client={queryClient}>
      <App />
      <ToastContainer position="top-center" autoClose={3000} />
    </QueryClientProvider>
  </AuthenticationProvider>
</React.StrictMode>,
  document.getElementById('root'),
);

reportWebVitals();
